import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isImmutable, is } from 'immutable'
import _ from 'lodash'

import Header from './components/Header'
import Footer from './components/Footer'
import Button from './components/Button'

import hocDialog from './hocDialog'

export default function (InnerComponent) {
    @hocDialog
    class HocDialogComponent extends Component {
        static propTypes = {
            closeDialog: PropTypes.func.isRequired,
            id: PropTypes.string,
            loading: PropTypes.bool,
            type: PropTypes.string.isRequired,
        }

        static defaultProps = {
            id: null,
        }

        componentDidMount() {
            // because of child reference
            this.forceRenderDialogComponent()
        }

        shouldComponentUpdate(nextProps) {
            // check all props (functions => false)
            return _.some(this.props, (value, key) => {
                if (_.isFunction(value)) return false
                if (isImmutable(value)) return !is(value, nextProps[key])

                return !_.isEqual(value, nextProps[key])
            })
        }

        onButtonClick = (type) => {
            const childCallback = (this._child && this._child.onButtonClick) || null

            if (childCallback) childCallback(type)
        }

        onCloseClick = () => {
            const { type, id, closeDialog } = this.props
            const childCallback = (this._child && this._child.onCloseClick) || null

            if (childCallback) childCallback(type)
            else closeDialog(type, id)
        }

        forceRenderDialogComponent = () => {
            this.forceUpdate()
        }

        renderHeader = () => {
            const defineFunction = _.get(this._child, 'defineHeader', () => {})
            const header = defineFunction() || {}

            return (
                <Header
                    text={header.text || '!!! Title !!!'}
                    icon={header.icon || 'base'}
                    onClose={this.onCloseClick}
                />
            )
        }

        renderFooter = () => {
            const { loading } = this.props
            const defineFunction = _.get(this._child, 'defineFooter', () => {})
            const buttons = defineFunction() || []

            if (_.isEmpty(buttons)) return null

            return (
                <Footer>
                    {_.map(buttons, (button) => (
                        <Button
                            key={button.type}
                            type={button.type}
                            text={button.text}
                            color={button.color}
                            name={button.name}
                            onClickHandler={this.onButtonClick}
                            loading={loading}
                        />
                    ))}
                </Footer>
            )
        }

        render() {
            return (
                <div className={'dialog-wrap'}>
                    {this.renderHeader()}
                    <InnerComponent
                        ref={(r) => (this._child = r)}
                        forceRenderDialogComponent={this.forceRenderDialogComponent}
                        {...this.props}
                    />
                    {this.renderFooter()}
                </div>
            )
        }
    }

    return HocDialogComponent
}
